import React from 'react';

export default function AgbPage() {
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="px-6 py-8 sm:px-10">
            <h1 className="text-3xl font-bold text-gray-900">Allgemeine Geschaeftsbedingungen</h1>
            <div className="mt-6 space-y-6 text-sm leading-6 text-gray-600">
              <p>
                Diese Demo-Anwendung dient derzeit der Produktvalidierung und stellt noch kein
                vollstaendig produktiv betriebenes Angebot dar.
              </p>
              <section>
                <h2 className="text-lg font-semibold text-gray-900">1. Leistungsbeschreibung</h2>
                <p className="mt-2">
                  NaturalMe verarbeitet hochgeladene Portraitbilder, um Make-up digital zu
                  reduzieren oder zu entfernen. Die bereitgestellten Ergebnisse koennen je nach
                  Bildqualitaet, Pose und Beleuchtung variieren.
                </p>
              </section>
              <section>
                <h2 className="text-lg font-semibold text-gray-900">2. Demo-Status</h2>
                <p className="mt-2">
                  Die hier gezeigte Version ist eine Vorabversion. Funktionsumfang, Preise,
                  Verfuegbarkeit und Speicherfristen koennen sich bis zu einem produktiven Launch
                  aendern.
                </p>
              </section>
              <section>
                <h2 className="text-lg font-semibold text-gray-900">3. Hochgeladene Inhalte</h2>
                <p className="mt-2">
                  Nutzer duerfen nur Bilder hochladen, fuer die sie die erforderlichen Rechte
                  besitzen. Personenbezogene oder sensible Inhalte sind nur im Rahmen der geltenden
                  Datenschutzregeln einzureichen.
                </p>
              </section>
              <section>
                <h2 className="text-lg font-semibold text-gray-900">4. Haftung</h2>
                <p className="mt-2">
                  Die Anwendung wird in der aktuellen Phase ohne Gewaehr fuer permanente
                  Verfuegbarkeit oder inhaltliche Fehlerfreiheit bereitgestellt. Fuer Ergebnisse aus
                  KI-gestuetzter Bildverarbeitung wird keine absolute Genauigkeit zugesichert.
                </p>
              </section>
              <section>
                <h2 className="text-lg font-semibold text-gray-900">5. Kontakt</h2>
                <p className="mt-2">
                  Rueckfragen zu den Bedingungen koennen ueber die Kontaktseite gestellt werden.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
